import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f9fafb',
        fontFamily: 'Arial, sans-serif',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
          padding: '48px 40px',
          maxWidth: '440px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>🚫</div>
        <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#111827', margin: '0 0 8px' }}>
          Access Denied
        </h1>
        <p style={{ color: '#6b7280', marginBottom: '8px' }}>
          You don't have permission to view this page. It may be restricted to certain roles.
        </p>
        {user && (
          <>
            <p style={{ color: '#9ca3af', fontSize: '14px', marginBottom: '4px' }}>
              Logged in as <strong>{user.fullName}</strong> ({user.role})
            </p>
            <p style={{ color: '#9ca3af', fontSize: '13px', marginBottom: '32px' }}>
              If you need access, contact your administrator.
            </p>
          </>
        )}
        <button
          onClick={() => navigate('/', { replace: true })}
          style={{
            background: '#eb0a1e',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '12px 28px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
